export default "__VITE_ASSET__CBRZ2w0I__"